import React from 'react';

import * as styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

class ExpandableFilterPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false
    };
  }

  toggleExpanded = () => {
    const current = this.state.expanded;
    this.setState({ expanded: !current });
  };

  render() {
    const getShowMoreContent = () => {
      return (
        <div onClick={this.toggleExpanded} className={styles.expand}>
          {this.state.expanded ? StringConstantsMixin.strings.SHOW_LESS : StringConstantsMixin.strings.SHOW_MORE}
        </div>
      );
    };

    return (
      <div className={`${styles.container} ${this.props.dividerBars ? styles.dividerBars : ''}`}>
        <div className={styles.title}>{this.props.title}</div>
        <div className={`${styles.body} ${this.state.expanded || this.props.truncate === undefined ? '' : styles.truncate}`}>
          <span>{this.props.content}</span>
        </div>
        {this.props.truncate ? getShowMoreContent() : ''}
      </div>
    );
  }
}

export default ExpandableFilterPanel;
